import api from '@/apis'
import fileDownload from 'js-file-download'
import Vuetify from '@/plugins/vuetify'
import { useScripts } from '@/scripts/scripts.ts'

const scripts = useScripts()

export default {
  state: {
    selected_device: [],
    selected_column_items: ['intent_identified', 'category', 'score', 'status', 'device_name', 'rating', 'response_time', 'comment', 'datetime', 'acquire', 'reply'],
    available_filter: ['bookmarked', 'fallback'],
    selected_filter: [],
    exclude_keyword: null,
    category_filter: null,
    search: '',
    table: {
      loading: false,
      page: 1,
      items_per_page: 10,
      total_items: 0,
      headers: [
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.date'), key: 'datetime' },
        { title: Vuetify.locale.t('$vuetify.__AI.right_bar.acquire'), key: 'acquire', width: '94px' },
        { title: Vuetify.locale.t('$vuetify.__AI.right_bar.reply'), key: 'reply' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.intent_identified'), key: 'intent_identified', width: '110px' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.intent_category'), key: 'category', width: '110px' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.response_time'), key: 'response_time', width: '110px' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.score'), key: 'score', width: '85px' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.status'), key: 'status', width: '115px' },
        { title: Vuetify.locale.t('$vuetify.__General.device'), key: 'device_name', width: '90px' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.user_rating'), key: 'rating', width: '87px' },
        { title: Vuetify.locale.t('$vuetify.__DatatableHeader.user_comment'), key: 'comment', width: '107px' },
        { title: '', key: 'bookmarked', sortable: false }
      ],
      items: []
    },
    datepicker: {
      dates: [new Date(Date.now() - 604800000), new Date(Date.now())]
    }
  },
  mutations: {
    SET_CONVERSATION_CHECK_DATEPICKER_DATES(state, payload) {
      state.datepicker.dates = payload
    },
    SET_CONVERSATION_CHECK_SELECTED_DEVICE(state, payload) {
      state.selected_device = payload
    },
    SET_CONVERSATION_CHECK_SELECTED_COLUMN_ITEMS(state, payload) {
      state.selected_column_items = payload
    },
    // ADD_CONVERSATION_CHECK_SELECTED_COLUMN_ITEMS(state, payload) {
    //   state.selected_column_items.push(payload)
    // },
    SET_CONVERSATION_CHECK_SELECTED_FILTER(state, payload) {
      state.selected_filter = payload
    },
    DELETE_CONVERSATION_CHECK_SELECTED_FILTER(state, payload) {
      state.selected_filter.splice(payload, 1)
    },
    SET_CONVERSATION_CHECK_EXCLUDE_KEYWORD(state, payload) {
      state.exclude_keyword = payload
    },
    DELETE_CONVERSATION_CHECK_EXCLUDE_KEYWORD(state) {
      state.exclude_keyword = null
    },
    SET_CONVERSATION_CHECK_CATEGORY_FILTER(state, payload) {
      state.category_filter = payload
    },
    DELETE_CONVERSATION_CHECK_CATEGORY_FILTER(state) {
      state.category_filter = null
    },
    SET_CONVERSATION_CHECK_SEARCH(state, payload) {
      state.search = payload
    },
    SET_CONVERSATION_CHECK_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_CONVERSATION_CHECK_TABLE_PAGE(state, payload) {
      state.table.page = payload
    },
    SET_CONVERSATION_CHECK_ITEMS_PER_PAGE(state, payload) {
      state.table.items_per_page = payload
    },
    SET_CONVERSATION_CHECK_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    },
    SET_CONVERSATION_CHECK_TABLE_HEADERS(state, payload) {
      state.table.headers = payload
    },
    SET_CONVERSATION_CHECK_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    },
    RESET_CONVERSATION_CHECK(state) {
      state.selected_device = []
      state.selected_filter = []
      state.exclude_keyword = null
      state.category_filter = null
      state.search = ''
      state.table = {
        loading: false,
        pages: 1,
        items_per_page: 10,
        total_items: 0,
        headers: [
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.date'), key: 'datetime' },
          { title: Vuetify.locale.t('$vuetify.__AI.right_bar.acquire'), key: 'acquire', width: '94px' },
          { title: Vuetify.locale.t('$vuetify.__AI.right_bar.reply'), key: 'reply' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.intent_identified'), key: 'intent_identified', width: '110px' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.intent_category'), key: 'category', width: '110px' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.response_time'), key: 'response_time', width: '110px' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.score'), key: 'score', width: '85px' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.status'), key: 'status', width: '115px' },
          { title: Vuetify.locale.t('$vuetify.__General.device'), key: 'device_name', width: '90px' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.user_rating'), key: 'rating', width: '87px' },
          { title: Vuetify.locale.t('$vuetify.__DatatableHeader.user_comment'), key: 'comment', width: '107px' },
          { title: '', key: 'bookmarked', sortable: false }
        ],
        items: []
      }
    }
  },
  actions: {
    async fetchConversation({ state, commit }, payload) {
      try {
        if (payload?.options?.page) commit('SET_CONVERSATION_CHECK_TABLE_PAGE', payload.options.page)
        if (payload?.options?.itemsPerPage) commit('SET_CONVERSATION_CHECK_ITEMS_PER_PAGE', payload.options.itemsPerPage)
        commit('SET_CONVERSATION_CHECK_TABLE_LOADING', true)
        commit('SET_CONVERSATION_CHECK_TABLE_ITEMS', [])

        const page = state.table.page
        const itemsPerPage = state.table.items_per_page
        const sortBy = payload?.options?.sortBy[0] ? payload.options.sortBy[0] : null
        let sort_by = null
        if (sortBy) {
          if (sortBy.key === 'remarks') sort_by = 'remarks'
          else sort_by = sortBy.key.slice(0, -5)
        }
        const order = sortBy ? sortBy.order : null

        const start_datetime = scripts.toBackendDate(state.datepicker.dates[0])
        const end_datetime = scripts.toBackendDate(state.datepicker.dates[state.datepicker.dates.length - 1])
        const bookmarked = state.selected_filter.includes('bookmarked')
        const fallback = state.selected_filter.includes('fallback')
        const category = state.category_filter ? state.category_filter.name : null

        let device_ids = ''
        state.selected_device.forEach((id, index) => {
          if (index > 0) device_ids = device_ids.concat(',')
          device_ids = device_ids.concat(id)
        })

        if (sort_by === null) {
          const response = await api.getConversation({
            start_datetime,
            end_datetime,
            bookmarked,
            fallback,
            category: category,
            exclude: state.exclude_keyword,
            search: state.search,
            device_ids: device_ids,
            limit: itemsPerPage,
            offset: page * itemsPerPage - itemsPerPage
          })
          if (response.data.success) {
            commit('SET_CONVERSATION_CHECK_TABLE_ITEMS', response.data.data)
            commit('SET_CONVERSATION_CHECK_TABLE_TOTAL_ITEMS', response.data.total)
          } else throw Error(response.data.message)
        } else {
          const response = await api.getConversation({
            start_datetime,
            end_datetime,
            bookmarked,
            fallback,
            category: category,
            exclude: state.exclude_keyword,
            search: state.search,
            device_ids: device_ids,
            limit: itemsPerPage,
            offset: itemsPerPage - itemsPerPage,
            sort_by: sort_by,
            order: order
          })
          if (response.data.success) {
            commit('SET_CONVERSATION_CHECK_TABLE_ITEMS', response.data.data)
            commit('SET_CONVERSATION_CHECK_TABLE_TOTAL_ITEMS', response.data.total)
          } else throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CONVERSATION_CHECK_TABLE_LOADING', false)
      }
    },
    async bookmarkConversation({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.bookmarking'), loading: true })
        const response = await api.bookmarkConversation({ params: payload })
        if (response.data.success) {
          dispatch('fetchConversation', { page: 1 })
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.success', Vuetify.locale.t('$vuetify.__AI.bookmark')),
            icon: 'check',
            timeout: '2000'
          })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async downloadConversation({ state, commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.downloading'), loading: true })

        const start_datetime = scripts.toBackendDate(state.datepicker.dates[0])
        const end_datetime = scripts.toBackendDate(state.datepicker.dates[state.datepicker.dates.length - 1])
        const bookmarked = state.selected_filter.includes('bookmarked')
        const fallback = state.selected_filter.includes('fallback')
        const category = state.category_filter ? state.category_filter.name : null

        let device_ids = ''
        state.selected_device.forEach((id, index) => {
          if (index > 0) device_ids = device_ids.concat(',')
          device_ids = device_ids.concat(id)
        })

        const response = await api.downloadConversation({
          start_datetime,
          end_datetime,
          bookmarked,
          fallback,
          category: category,
          exclude: state.exclude_keyword,
          device_ids: device_ids
        })
        if (response.status === 200) {
          fileDownload(response.data, `${start_datetime}-${end_datetime}-Conversation.xlsx`)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.download'), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async fetchCategoryOptions({ state, commit }) {
      try {
        commit('SET_FILTER_DIALOG_CATEGORY_ITEMS', [])

        let device_ids = ''
        state.selected_device.forEach((id, index) => {
          if (index > 0) device_ids = device_ids.concat(',')
          device_ids = device_ids.concat(id)
        })

        const response = await api.getCategoryList({ device_ids: device_ids })
        if (response.data.success) {
          commit('SET_FILTER_DIALOG_CATEGORY_ITEMS', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
